/*eslint no-script-url: 0 */
import React, { Component } from "react";
import Constants from '../../Config/Config';
import Parser from 'html-react-parser';

class OtherMenu extends Component {

	constructor(props) {
	    super(props);
	    this.state = {
			otherMenu: [
				{
					"ID": 189,
					"title": "Acrylic Mounting",
					"url": "https://www.acrylicmountingonline.com.au/",
				},
				{
					"ID": 190,
					"title": "Acrylic Blocks",
					"url": "https://www.acrylicmountingonline.com.au/collections/acrylic-photo-blocks",
				},
				{
					"ID": 191,
					"title": "Acrylic Mounting Panels",
					"url": "https://www.acrylicmountingonline.com.au/collections/acrylic-mounting-panels",
				},
				{
					"ID": 192,
					"title": "www.acrylicmountingonline.com.au",
					"url": "https://www.acrylicmountingonline.com.au/",
				}
			]
	    }
  	}

  	render() {
  		const { otherMenu } = this.state;
	    return (
			<div className="footer-col">
				<h4>Other</h4>
				<ul>
					{otherMenu.map( (menu) =>
				        <li key={menu.ID}><a href={menu.url} target="_blank" rel="noopener noreferrer">{Parser(menu.title)}</a></li>
				    )}
				</ul>
				<div className="bttn">
					<a href="mailto:contact@JustPictureFraming.com.au" className="aa"><i><img className="one" src={Constants.URL.ImageURL+"/mail.png"} alt="Email" /> <img className="two" src={Constants.URL.ImageURL+"/mail1.png"} alt="Email" /></i>Click Here To Email this site</a>
				</div>
			</div>
	    );
  	}
}

export default OtherMenu;